import WaveHeader from "../../../components/WaveHeader"
import movieImage from "../../../assets/movie-bg.jpg"
import { Col, Container, Row } from "react-bootstrap"
import styled from "styled-components"
import colors from "../../../utils/style/colors"
import movieImg from "../../../assets/movie-theater.jpg"
import { Breadcrumbs, Typography } from "@mui/material"
import ButtonPrimary from "../../../components/ButtonPrimary"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFaceFrown, faWarning } from "@fortawesome/free-solid-svg-icons"
import {
  useGetCardOrderQuery,
  useGetCurrentCardsPricesQuery,
} from "../../../features/orderSlice"
import { Loader } from "../../../utils/Atoms"
import { StockOrderType } from "../../../models/cardStockOrder"
import CardPrice from "../../../models/cardPrice"
import { Fragment, useMemo, useState } from "react"
import InternError from "../../../components/InternError"
import { formatPrice } from "../../../utils/utils"
import { Link } from "react-router-dom"
import CardModal from "../../../components/CardModal"
import { CardOrderDto, OrderStatusType, OrderType } from "../../../models/order"
import CardOrder from "../../../components/CardOrder"

const ContainerStyled = styled(Container)`
  h2 {
    font-size: 1.5rem;
    color: ${colors.violet};
  }
  h3 {
    font-size: 1.3rem;
    color: ${colors.darkViolet};
  }
`

const DivStyled = styled.div``
const LinkStyled = styled(Link)`
  text-decoration: none;
  color: #929292;
  &:hover {
    text-decoration: underline;
    color: ${colors.violet};
  }
`

function Orders({ type }: { type: OrderType }) {
  const {
    data: orders = [],
    isLoading: isOrderLoading,
    isSuccess: isOrderSuccess,
    isError: isOrderError,
  } = useGetCardOrderQuery({ type: type })

  const pendingOrdersData = useMemo(() => {
    let datas = orders.filter(
      (cardOrder: CardOrderDto) => cardOrder.status === OrderStatusType.ToHandle
    )

    return datas
  }, [orders])

  const pastOrdersData = useMemo(() => {
    let datas = orders.filter(
      (cardOrder: CardOrderDto) => cardOrder.status !== OrderStatusType.ToHandle
    )

    return datas
  }, [orders])

  let pendingOrder
  let pastOrder
  if (isOrderError) {
    pendingOrder = <InternError />
    pastOrder = <InternError />
  } else if (isOrderSuccess) {
    pendingOrder = (
      <Fragment>
        {pendingOrdersData &&
          pendingOrdersData.map((order: CardOrderDto) => (
            <CardOrder order={order} key={order.id}></CardOrder>
          ))}
        {pendingOrdersData &&
          pendingOrdersData.length === 0 &&
          "Aucune commande"}
      </Fragment>
    )

    pastOrder = (
      <Fragment>
        {pastOrdersData &&
          pastOrdersData.map((order: CardOrderDto) => (
            <CardOrder order={order} key={order.id}></CardOrder>
          ))}
        {pastOrdersData && pastOrdersData.length === 0 && "Aucune commande"}
      </Fragment>
    )
  } else if (isOrderLoading) {
    pendingOrder = <Loader />
    pastOrder = <Loader />
  }

  return (
    <Fragment>
      <h2>Vos commandes en cours : </h2>
      <div className="container-fluid py-3 mb-3 mb-lg-5 px-0">
        <Col sm={10} lg={7}>
          {pendingOrder}
        </Col>
      </div>
      <h2>Vos commandes passées cette année : </h2>
      <div className="container-fluid py-3 mb-3 mb-lg-5 px-0">
        <Col sm={10} lg={7}>
          {pastOrder}
        </Col>
      </div>
    </Fragment>
  )
}

function Movie() {
  const {
    data: currentCardsPrices = [],
    isLoading: isCardPriceLoading,
    isSuccess: isCardPriceSuccess,
    isError: isCardPriceError,
  } = useGetCurrentCardsPricesQuery()

  const [showOrderCard, setShowOrderCard] = useState(false)

  const cardsPrices = useMemo(() => {
    let cards: any = []

    if (currentCardsPrices) {
      let poolCards = currentCardsPrices.find(
        (cardPrice: CardPrice) => cardPrice.type === StockOrderType.Pool
      )
      let movieCards = currentCardsPrices.find(
        (cardPrice: CardPrice) => cardPrice.type === StockOrderType.Movie
      )

      cards[StockOrderType.Pool] = poolCards
      cards[StockOrderType.Movie] = movieCards
    }
    return cards
  }, [currentCardsPrices])

  let moviePriceContent = isCardPriceLoading ? (
    <Loader />
  ) : isCardPriceSuccess ? (
    <DivStyled className="my-2">
      <Row>
        <Col xs={"auto"}>Prix d'une place adulte :</Col>
        <Col style={{ fontWeight: "600" }}>
          {formatPrice(cardsPrices[StockOrderType.Movie]?.adultPrice)}
        </Col>
      </Row>
      <Row>
        <Col xs={"auto"}>Prix d'une place enfant :</Col>
        <Col style={{ fontWeight: "600" }}>
          {formatPrice(cardsPrices[StockOrderType.Movie]?.childPrice)}
        </Col>
      </Row>
      {/*  <Row className="mt-3">
        <Col xs={"auto"}>
          <FontAwesomeIcon icon={faCircleInfo} color={colors.violet} />
          &nbsp; Au delà de 12 places achetées par année civile, les places vous
          reviennent au prix coûtant{" "}
          <span style={{ color: "grey", fontSize: "1rem" }}>
            ({formatPrice(cardsPrices[StockOrderType.Movie]?.adultCostPrice)}{" "}
            pour une place adulte et{" "}
            {formatPrice(cardsPrices[StockOrderType.Movie]?.childCostPrice)}{" "}
            pour une place enfant)
          </span>
        </Col>
      </Row> */}
      <Row className="mt-3">
        <Col xs={"auto"}>
          <FontAwesomeIcon icon={faWarning} color="darkred" />
          &nbsp; Merci de vous présenter muni de votre moyen de paiement pour
          réceptionner vos places. Dans le cas contraire, celles-ci ne pourront
          pas vous être délivrées.
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={"auto"}>
          <FontAwesomeIcon icon={faWarning} color="darkred" />
          &nbsp; En cas de dépassement de la validité, les billets CSE ne sont
          ni repris, ni échangés, ni prorogés et non valables en cas de rature.
        </Col>
      </Row>
    </DivStyled>
  ) : (
    <InternError />
  )

  return (
    <div>
      <WaveHeader title="Places de cinéma" image={movieImage} />
      <ContainerStyled>
        <Breadcrumbs aria-label="breadcrumb" className="mb-4">
          <LinkStyled color="gray" to="/commandes">
            Mes commandes
          </LinkStyled>
          <Typography color="text.primary">Places de cinéma</Typography>
        </Breadcrumbs>
        <h2>Vous souhaitez vous détendre devant un bon film ? </h2>
        <div className="d-flex flex-wrap flex-lg-nowrap gap-4 gap-md-5 py-3 mb-3 mb-lg-5">
          <div>
            <img
              src={movieImg}
              alt="Pop corn"
              className="img-fluid"
              style={{
                borderRadius: "4rem",
                boxShadow: "4px 4px 10px grey",
              }}
            />
          </div>
          <div className="mt-md-4">
            <h3>Profitez des tarifs réduits du CSE ! </h3>
            {isCardPriceSuccess && !cardsPrices[StockOrderType.Movie] && (
              <div style={{ color: "darkred" }}>
                <FontAwesomeIcon icon={faFaceFrown} color="darkred" /> Aucun
                prix n'a été paramétré pour le moment... Veuillez nous contacter
                si le problème persiste.
              </div>
            )}
            {moviePriceContent}
            <br />
            <div className="text-center text-md-start">
              <ButtonPrimary
                label="Commander des places"
                type="button"
                disabled={
                  isCardPriceSuccess && !cardsPrices[StockOrderType.Movie]
                }
                onClick={() => setShowOrderCard(true)}
              />
            </div>
          </div>
        </div>
        <Orders type={OrderType.Movie} />
        <CardModal
          type={StockOrderType.Movie}
          show={showOrderCard}
          handleClose={() => setShowOrderCard(false)}
        />
      </ContainerStyled>
    </div>
  )
}

export default Movie
